import { ChangeDetectionStrategy, Component } from '@angular/core';

export interface BookletBadgeInfo {
  abbr: string;
  name: string;
  description: string;
  grey: string;
  orange: string;
  yellow: string;
  green: string;
  red: string;
}

const NOT_APPLICABLE = 'Non previsto';

@Component({
  selector: 'casa-doc-booklet-badges-legend',
  templateUrl: './booklet-badges-legend.component.html',
  styleUrls: ['./booklet-badges-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookletBadgesLegendComponent {
  readonly badges: BookletBadgeInfo[] = [
    {
      abbr: 'CCF',
      name: 'Contratto Casa Doc Firmato',
      description: 'Contratto Casa Doc caricato e firmato dal venditore.',
      grey: NOT_APPLICABLE,
      orange: 'Caricato, firma ancora da validare',
      yellow: NOT_APPLICABLE,
      green: 'Caricato e firmato',
      red: 'Non caricato',
    },
    {
      abbr: 'ADP',
      name: 'Atto di Provenienza',
      description:
        "Atto di provenienza dell'immobile, caricato dal venditore oppure cercato dalla segreteria.",
      grey: NOT_APPLICABLE,
      orange:
        'Nomi dei proprietari non inseriti, oppure ricerca / verifica in corso con segretario assegnato',
      yellow: NOT_APPLICABLE,
      green: 'Nomi dei proprietari inseriti, documento caricato e conforme',
      red:
        'Ricerca richiesta senza segretario "Ricerca Atto" assegnato; ricerca non richiesta e documento ' +
        'non caricato; documento caricato e non conforme',
    },
    {
      abbr: 'AAA',
      name: 'Accesso agli Atti',
      description:
        'Catasto caricato, accesso agli atti richiesto e protocollato, ' +
        'diritti di segreteria pari a 0 oppure pagati.',
      grey: NOT_APPLICABLE,
      orange:
        'Catasto e istruttore presenti, ma manca il numero di protocollo, la data di richiesta accesso ' +
        'agli atti oppure il pagamento dei diritti di segreteria',
      yellow:
        'Catasto caricato e numero di protocollo inserito, ma data di accesso agli atti per il ' +
        'tecnico non popolata',
      green:
        'Catasto caricato, numero di protocollo inserito, data di richiesta accesso agli atti inserita, ' +
        'data di accesso agli atti inserita e diritti di segreteria accesso agli atti pari a 0 oppure pagati',
      red: 'Catasto non caricato e/o segretario "Istruttore" non assegnato',
    },
    {
      abbr: 'APE',
      name: 'Attestato di Prestazione Energetica',
      description: 'APE richiesto a Casa Doc oppure fornito direttamente dal venditore.',
      grey: NOT_APPLICABLE,
      orange:
        'Richiesto con questionario, foto e tecnico presenti ma APE non ancora caricato o da verificare; ' +
        'oppure non richiesto, caricato e da verificare',
      yellow: NOT_APPLICABLE,
      green: 'Caricato e conforme',
      red:
        'Non richiesto e non caricato; caricato e non conforme; richiesto con questionario, foto o tecnico ' +
        'mancanti',
    },
    {
      abbr: 'RT',
      name: 'Relazione Tecnica',
      description: 'Relazione tecnica redatta dal tecnico assegnato al libretto.',
      grey: NOT_APPLICABLE,
      orange: 'Tecnico assegnato ma file non ancora caricato, oppure caricato e da verificare',
      yellow: NOT_APPLICABLE,
      green: 'Caricata e conforme',
      red: 'Tecnico non assegnato',
    },
    {
      abbr: 'EXTRA',
      name: 'Documento Extra',
      description: 'Documento extra e relativo contratto, presente solo se è assegnato un tecnico extra.',
      grey: 'Nessun tecnico extra assegnato (extra non richiesto)',
      orange: 'Contratto extra firmato ma documento extra non caricato o da verificare',
      yellow: NOT_APPLICABLE,
      green: 'Documento extra caricato e conforme',
      red: 'Contratto extra non caricato o non firmato; documento extra caricato e non conforme',
    },
    {
      abbr: 'DICV',
      name: 'Data Invio Costi Venditore',
      description: 'Data invio riepilogo costi al venditore.',
      grey: 'Stato libretto = Nuovo o In Istruttoria',
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data inserita dal contabile dopo aver inviato il file',
      red: 'Stato libretto = Doc Ready',
    },
    {
      abbr: 'PCD',
      name: 'Pagamento Casa Doc',
      description: 'Pagamento cliente riepilogo costi su CC CasaDoc.',
      grey: "Fino a che non c'è DICV verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data popolata dopo bonifico ricevuto',
      red: 'Quando DICV è verde',
    },
    {
      abbr: 'DFCD',
      name: 'Data Fattura Casa Doc',
      description: 'Data invio fattura Casa Doc al cliente.',
      grey: "Fino a che non c'è PCD verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data inserita dal contabile',
      red: 'Quando PCD è verde',
    },
    {
      abbr: 'FCD',
      name: 'Fattura Casa Doc',
      description: 'Fattura Casa Doc inviata e caricata.',
      grey: "Fino a che non c'è PCD verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Fattura inviata e caricata',
      red: 'PCD verde',
    },
    {
      abbr: 'E:DICV',
      name: 'Data Invio Costi Venditore Extra',
      description: 'Data invio riepilogo costi extra al venditore.',
      grey: 'Extra non richiesto o non caricato',
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data inserita dal contabile dopo aver inviato il file extra',
      red: 'Extra caricato e data mancante',
    },
    {
      abbr: 'E:PCD',
      name: 'Pagamento Extra Casa Doc',
      description: 'Pagamento cliente riepilogo costi extra su CC CasaDoc.',
      grey: "Fino a che non c'è E:DICV verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data popolata dopo bonifico ricevuto',
      red: 'Quando E:DICV è verde',
    },
    {
      abbr: 'E:DFCD',
      name: 'Data Fattura Extra Casadoc',
      description: 'Data invio fattura extra Casadoc al cliente.',
      grey: "Fino a che non c'è E:PCD verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Data inserita dal contabile',
      red: 'Quando E:PCD è verde',
    },
    {
      abbr: 'E:FCD',
      name: 'Fattura Extra Casadoc',
      description: 'Fattura Extra Casadoc inviata e caricata.',
      grey: "Fino a che non c'è E:PCD verde",
      orange: NOT_APPLICABLE,
      yellow: NOT_APPLICABLE,
      green: 'Fattura inviata e caricata',
      red: 'E:PCD verde',
    },
  ];

  trackByAbbr(_index: number, badge: BookletBadgeInfo): string {
    return badge.abbr;
  }
}
